import { api } from "./api";
import type { ActivityLog } from "@/types/models";

interface PaginatedResponse {
  data: ActivityLog[];
  meta: {
    total: number;
    limit: number;
    offset: number;
  };
}

export const activityLogService = {
  list: (params?: Record<string, string | number>) =>
    api
      .get<PaginatedResponse>("/activity-logs", { params })
      .then((r) => r.data),
};
